import React from "react";
import Icon from "../../assets/Icon";

function PreviewFooter() {
  return (
    <div className="flex justify-between w-full items-end px-8">
      <p className="text-[.8rem]">
        © {new Date().getFullYear()}, HirePlusPlus Technologies Private Limited, India
      </p>
      <div className="">
        <p className="flex justify-end items-center gap-2 text-[.8rem]">
          Powered by <Icon type="hire-logo" width="70" height="40" />{" "}
        </p>
        <p className="flex items-center gap-2 text-[.8rem] ">
          <Icon type="email-logo" width="18" height="18" />{" "}
          <p className="">support@hireplusplus.com</p>
        </p>
      </div>
    </div>
  );
}

export default PreviewFooter;
